const initialState = {
  emailFound: false,
  user: null,
  loading: false,
  resetStatus: null,
  error: null,
  codeMatched: false,
  code: null,
  codeExpiresAt: null,
  canResendAt: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case 'EMAIL_FOUND':
      return {
        ...state,
        emailFound: true,
        user: payload.email,
        codeExpiresAt: payload.expiresAt,
        canResendAt: payload.canResendAt,
      };
    // Same shape EMAIL_FOUND produces, minus the code lifetimes -- a
    // deep link carries no expiry information, so the countdown simply
    // does not render. The code itself still expires server-side.
    case 'RESET_LINK_OPENED':
      return {
        ...state,
        emailFound: true,
        user: payload.email,
      };
    case 'CODE_MATCHED':
      return {
        ...state,
        codeMatched: true,
        code: payload,
      };
    case 'PASS_RESET_COMPLETE':
      return {
        emailFound: false,
        user: null,
        loading: false,
        resetStatus: null,
        error: null,
        codeMatched: false,
        code: null,
        codeExpiresAt: null,
        canResendAt: null,
      };
    case 'ERROR':
      return {
        ...state,
        error: payload.msg,
      };
    case 'CLEAR_ERROR':
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
}
